module.exports = __webpack_public_path__ + "static/media/photo222.81133b1f.jpg";